// Expo Router dynamic route for a single proposal. The screen body lives in a bracket-free sibling
// (ProposalDetailScreen) so unit tests can import it without resolving a `[id]` path.
import { ProposalDetailScreen } from './ProposalDetailScreen';

export default function ProposalDetailRoute() {
  return <ProposalDetailScreen />;
}
